import React from 'react';
import { Link } from 'react-router-dom';
import './Website.css';

const chromeStoreUrl = 'https://chromewebstore.google.com/detail/unsubscriber-mass-unsubsc/jpaajppadbkogfmgofandmiglolmecea';

export default function UpgradeCancelled() {
  return (
    <main className="site-page utility-page centered-page">
      <section className="result-card">
        <span className="result-mark result-muted">!</span>
        <p className="eyebrow">Checkout cancelled</p>
        <h1>No charge was made.</h1>
        <p>
          You can open the extension listing whenever you are ready, or contact support if Stripe did not behave as expected.
        </p>
        <div className="result-actions">
          <a className="button button-primary" href={chromeStoreUrl} target="_blank" rel="noreferrer">Get extension</a>
          <Link className="button button-secondary" to="/contact">Contact support</Link>
        </div>
      </section>
    </main>
  );
}
